import { Glyphicon } from 'react-bootstrap'
import styled, { withTheme } from 'styled-components'

const getStyles = props => {
  if (props.raw) {
    return
  } else {
    return `
      color: var(--clr-grey-3-to-text);
      line-height: 40px;
      font-size: 1.8em;
      cursor: pointer;

      &:hover {
        color: var(--clr-accent-to-black)
      }
    `
  }
}

const GlyphIcon = styled(Glyphicon).attrs(props => ({
  glyph: props.glyph
}))`
  ${props => getStyles(props)}
`

export default withTheme(GlyphIcon)



// WEBPACK FOOTER //
// ./src/components/Glyphicon/index.js